// extracted by mini-css-extract-plugin
export default {"l":"a923205cc5"};